import React from 'react';
import {connect} from 'react-redux';
import styles from "../login_page.module.scss";
import {dismiss_error} from "../../_redux/_actions/authentication.actions";
import {Alert} from "react-bootstrap";

const requestMessage = (requestError) => {
  if (typeof requestError === 'string' || requestError instanceof String) {
    return requestError
  }
  if (Array.isArray(requestError)) {
    if (typeof requestError[0] === 'string' || requestError[0] instanceof String) {
      return requestError.join("\n")
    }
    if (requestError[0].errorText && (typeof requestError[0].errorText === 'string' || requestError[0].errorText instanceof String)) {
      return requestError.reduce((accumulator, currentValue) => (accumulator + currentValue.errorText + '\n'),'');
    }
  }
  return ''
}

const ErrorMessage = (props) => {
  const {requestError, dismissError} = props;
  return ( requestError && (
    <Alert onClose={dismissError} variant="danger" className={styles.alertMessage} dismissible>
      <Alert.Heading>Error!</Alert.Heading>
      <p>
        {requestMessage(requestError)}
      </p>
    </Alert>)
  )
};

function mapStateToProps(state) {
  const { requestError } = state.authentication;
  return { requestError };
}

const mapDispatchToProps = dispatch => ({
  dismissError: () => dispatch(dismiss_error())
});


export default connect(
  mapStateToProps, mapDispatchToProps
)(ErrorMessage);